    <template>
    <div class="circadianLightsPlan_main" :class="{'cn':version == '1'}">
        <div class="circadianLightsPlan_top">
            <div class="box btn" @click="linkToFun('/siteManagement')">
                <i class="iconfont icon-back"></i><span class="span1">{{$t('App.room_light.text1')}}</span>
            </div>
            <div class="l"></div>
            <div class="box"><span class="span2">{{$t('App.sideBar.text14')}} →</span></div>
            <div class="box">
                <span class="span1">{{$t('App.siteManagement.text39')}}</span>
            </div>
        </div>
        <div class="circadianLightsPlan_content">
            <div class="toolbar">
                <div class="toolbar_l">
              <!--       <el-select v-model="userId">
                        <el-option
                            v-for="item in userNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-input :placeholder="$t('App.placeholder.text4')" v-model="keywords" @keyup.native="getExcelListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getExcelList()"></i>
                    </el-input>
                </div>
                <div class="toolbar_r">
                    <div class="btn" @click="uploaderCirExcelFun()">
                        <!-- <img src="../img/newMaintenanceStaff.png"> -->
                        <span>{{$t('App.siteManagement.text40')}}</span>
                    </div>
                </div>
            </div>
            <div class="table_box">
                <div class="table_top">
                    <div class="main_top">
                        <div class="main_top_l">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDel(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                    <el-table
                        ref="excelDataList"
                        v-loading="loading.excelDataList"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="excelDataList">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'index'"
                            align="left"
                            :width="70">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in repairArr"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            </el-table-column>
                            <el-table-column
                            align="center"
                            :min-width="100"
                            :label="$t('App.lights.text6')">
                            <template slot-scope="scope">
                                <!-- <span class="btn" @click="postLoad(scope.row)" :title="$t('App.room.text59')">
                                    <i class="iconfont icon-xiazai" style="font-size: 1rem"></i>
                                </span> -->
                                <span class="btn" @click="postDel(scope.row)" :title="$t('App.lights.text1')">
                                    <i class="iconfont icon-delete"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-checkbox-group>
                <div class="pagination_box">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 上传计划 -->
        <div class="map_binding_wrap scrollbar_style" v-show="bindingShowBg">
            <div class="map_binding_wrap_bg" @click="bindingTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':bindingShow}">
                <div class="tk_title">
                    <span class="span1">{{$t('App.siteManagement.text41')}}</span>
                    <span class="span2" @click="bindingTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="box">
                    <!-- <div class="tabs2">
                        <span class="span1">!</span><span class="span2">{{$t('App.siteManagement.text42')}}<span class="span3" @click="getInputExcel()">{{$t('App.siteManagement.text43')}}</span>{{$t('App.siteManagement.text44')}}</span>
                    </div> -->
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="excelUploadData"
                        :action="actionExcelUrl"
                        :on-progress="hotelLogoProgress"
                        :on-change="excelChange">
                        <span><i class="iconfont icon-shangchuan"></i><span>{{$t('App.siteManagement.text47')}}</span></span>
                    </el-upload>
                    <div class="upload_progress" v-if="uploadHotelLogoStatus == '1'">
                        <div class="l">
                            <div class="i_box">
                                <i class="el-icon-link"></i>
                            </div>
                            <div class="text">
                               {{$t('App.siteManagement.text27')}}
                            </div>
                            <el-progress :percentage="uploadHotelLogoSlider" :show-text="false"></el-progress>
                        </div>
                        <div>{{uploadHotelLogoSlider}}%</div>
                    </div>
                </div>
                <!-- <div class="btn_box">
                    <div class="btn" @click="batchInput()">Preserve</div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">

    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'

	export default {
		name:'circadianLightsPlan',
		data () {
			return{
                userId:'',
                userNav:[],
                keywords:'',

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                repairArr:[],
                excelDataList:[],
                excelDataIdList:[],

                currentPage:1,
                pageSize:20,
                total:0,

                circadianLightsPlanTkTitle:'',
                circadianLightsPlanTkShowbg:false,
                circadianLightsPlanTkShow:false,
                circadianLightsPlanForm:{
                    name:'',
                    number:'',
                    phone:'',
                    email:'',
                },
                circadianLightsPlanId:'',

                bindingShowBg:false,
                bindingShow:false,
                allDevSelect:'0',
                mapNewDevList:[],
                actionExcelUrl:'',
                excelUploadData:{
                    username:'',
                    client_key:'',
                    token:'',
                },
                uploadHotelLogoStatus:'0',

				loading:{
				}
			}
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
            }),
        },
		components:{
			// 'sideBar':sideBar
		},
		mounted(){
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:false,
            })

            this.repairArr = [
                {prop:'cvsname',label:this.$t('App.name'),minWidth:70},
                {prop:'upuser',label:this.$t('App.siteManagement.text45'),minWidth:100},
                {prop:'create_time',label:this.$t('App.siteManagement.text46'),minWidth:160},
            ];
            this.excelUploadData.username = this.username;
            this.excelUploadData.client_key = this.client_key;
            this.excelUploadData.token = this.token;
            this.actionExcelUrl = allUrl.roomLight.CirExcel;
            this.getExcelList();
		},
		methods:{
			linkToFun(val){
				this.$router.push({path:val});
				this.$store.commit('ROUTERSTRFUN',{
					routerStr:val,
				})
			},
            /*用户下拉列表*/
            getUserNav(callback){
                base.ajax_post(
                    allUrl.userManagement.userNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.userNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            uploaderCirExcelFun(){
                this.bindingShowBg = true;
                this.$nextTick(function(){
                    this.bindingShow = true;
                })
            },
            bindingTkClose(){
                let this_ = this;
                this.bindingShowBg = false;
                setTimeout(function(){
                    this_.bindingShow = false;
                },400)
            },
            hotelLogoProgress(event){
                console.log(event,'========')
                this.uploadHotelLogoStatus = '1';
                this.uploadHotelLogoSlider = parseInt(event.percent);
            },
            excelChange(res,file){
                console.log(res,file)
                let this_ = this;
                this.hotelLogoName = res.name;
                this.hotelLogoSize = res.size/1000;
                if(res.status == 'success'){
                    if(res.response.code == '0000'){
                        this.uploadHotelLogoStatus = '2';
                        this.$message({
                          showClose: true,
                          message: res.response.msg,
                          type: 'success'
                        });
                        this.getExcelList();
                        this.bindingShowBg = false;
                        setTimeout(function(){
                            this_.bindingShow = false;
                        },400)
                    }else{
                        this.$alert(res.response.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        this.uploadHotelLogoStatus = '3';
                    }
                }else if(res.status== 'ready'){
                    this_.uploadHotelLogoStatus = '0';
                }else{
                    this_.uploadHotelLogoStatus = '3';
                    this.bindingShowBg = false;
                    setTimeout(function(){
                        this_.bindingShow = false;
                    },400)
                }
            },
            getInputExcel(){
                base.ajax_post(
                    allUrl.roomLight.download,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        var $eleForm = $("<form method='get'></form>");
                        $eleForm.attr("action",data.data.url);
                        $(document.body).append($eleForm);
                        //提交表单，实现下载
                        $eleForm.submit();
                        // this.getExcelList();
                    },
                    this
                )
            },
            postLoad(obj){
                base.ajax_post(
                    allUrl.roomLight.load,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        planId:obj.id,
                    },
                    {},
                    data=>{
                        var $eleForm = $("<form method='get'></form>");
                        $eleForm.attr("action",data.data.url);
                        $(document.body).append($eleForm);
                        //提交表单，实现下载
                        $eleForm.submit();
                        // this.getExcelList();
                    },
                    this
                )
            },
            /*删除维修人员*/
            postDel(obj,type){
                let planId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('APP.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(planId == ''){
                                planId = id;
                            }else{
                                planId += ','+id;
                            }
                        }
                    }
                }else{
                    planId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text36'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.roomLight.del,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                planId:planId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getExcelList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getExcelListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getExcelList();
                }
            },
            getExcelList(callback){
                base.ajax_post(
                    allUrl.roomLight.excelList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        page:this.currentPage,
                        count:this.pageSize,
                        keywords:this.keywords,
                        // userId:this.userId,
                    },
                    {},
                    data=>{
                         console.log(data)
                        this.excelDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.excelDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        for(let d of this.excelDataList){
                            this.excelDataIdList.push(d.id);
                        }

                        let i = 1 + (this.currentPage-1)*this.pageSize;
                        for(let d of this.excelDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getExcelList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                this.checkList = val ? this.excelDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.excelDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.excelDataIdList.length;
            },
        },
        watch:{
            // userId:function(){
            // },
        }
    }
</script>

<style type="text/css" lang="less">
    .circadianLightsPlan_main{
		width: 100%;
		height: 100%;
		// height: 105rem;
		min-height: 50rem;
		// min-width: 120rem;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		background: #F6F8FA;
        &.cn{
            .circadianLightsPlan_content{
                .toolbar .toolbar_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .table_box{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
        }
        .circadianLightsPlan_top{
            display: flex;
            width: 100%;
            align-items: center;
            padding-left: 1rem;
            height: 2.67rem;
            background: #FFFFFF;
            box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
            .span1{
                font-size:1rem;
                font-family:AlibabaPuHuiTiR;
                color:rgba(51,51,51,1);
            }
            .span2{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #A3AFBB;
            }
            .box{
                margin-left: 1rem;
            }
            .btn{
                line-height: 2.67rem;
                cursor: pointer;
                .iconfont{
                    margin-right: 0.5rem;
                    font-size: 0.8rem;
                }
            }
        }
        .circadianLightsPlan_content{
            height: calc(100% - 3rem);
            margin: 1.5rem 0;
            .toolbar{
                padding: 0 1.67rem;
                display: flex;
                justify-content: space-between;
                .toolbar_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 22rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .toolbar_r{
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1rem;
                        }
                    }
                }
            }
            .table_box{
                height: calc(100% - 5.67rem);
                margin: 0.8rem 1.67rem 0;
                background-color:#fff;
                border: 1px solid rgba(240, 240, 240, 1);
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 3.2rem;line-height: 3.2rem;
                    .main_top_l{
                        margin-left: 1.1rem;
                        display: flex;
                        .btn{
                            margin-left: 1.29rem;
                            display: flex;align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            i{
                                font-size:0.8rem;
                                color: #C6CDD5;
                            }
                            span{
                                margin-left: 0.5rem;
                            }
                        }
                    }
                }
                .el-checkbox-group{
                    height: calc(100% - 10rem);
                }
                .el-table{
                    .el-checkbox{
                        margin-left: 1.1rem;
                    }
                    .btn{
                        padding: 0.5rem;
                        cursor: pointer;
                        &+.btn{
                            margin-left: 0.2rem;
                        }
                        i{
                            color: #A3AFBB;
                            font-size:0.8rem;
                        }
                        &:hover{
                            i{
                                color: #05CFAB;
                            }
                        }
                    }
                    th{
                        font-weight:initial;
                        height: 3rem;
                        border-top: 1px solid #F0F0F0;
                        border-bottom: 1px solid #F0F0F0;
                        padding: 0;
                        background: #F6F8FA;
                        &>.cell{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                    }
                    td{
                        padding: 0;
                        height: 3rem;
                        &>.cell,.el-checkbox__label{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            }
                    }
                    .maintenanceStatus{
                        .text_1{
                            color: #05cfab;
                        }
                        .text_2{
                            color: #FF0C4D;
                        }
                    }
                }
                .pagination_box{
                    .el-pagination{
                        float: right;
                        margin-top: 0.5rem;
                    }
                    height: 2.5rem;line-height: 2.5rem;
                    .btn-prev .el-icon{
                        font-size:1rem;
                        color: #666666;
                        font-family: PingFang-SC-Medium;
                    }
                    button{
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: #F6F8FA;
                        border-radius: 0.2rem;
                    }
                    .el-pager li{
                        margin-left: 0.83rem;
                        width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                        padding: 0;
                        background: #F6F8FA;
                        border-radius: 0.2rem;
                        &:hover{
                            color: rgba(5,207,171,1);
                            background-color: rgba(5,207,171,0.1);
                        }
                    }
                    .btn-next{
                        margin-left: 0.83rem;
                    }
                    .el-pager li.active{
                        background: #05CFAB;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .map_binding_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .map_binding_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .tk_box{
                position: absolute;
                width: 35rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -35rem;
                transition: all 0.8s;
                &.tk_show{
                    right: 0rem; 
                }
                .tk_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box{
                    height: calc(100% - 17rem);
                    margin-top: 1.96rem;
                    // height: 100%;
                }
                .tabs2{
                    position: relative;
                    text-align: left;
                    width:calc(100% - 5rem);
                    height:4.42rem;line-height: 1.9rem;
                    padding-top:0.5rem;
                    padding-left:3rem;
                    border-radius:0.17rem;
                    margin: 0 2.5rem;
                    background:rgba(5,207,171,0.1);

                    .span1{
                        position:absolute;
                        left: 1rem;top: 1.6rem;
                        display: inline-block;
                        width:1.13rem;
                        height:1.13rem;line-height: 1.13rem;
                        border-radius: 50%;
                        background:rgba(5,207,171,1);
                        font-weight:500;
                        color: #fff;
                        text-align: center;
                    }
                    .span2{
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(51,51,51,1); 
                        .span3{
                            color: #05CFAB;
                            text-decoration:underline;
                            cursor: pointer;
                        }
                    }
                }
                .avatar-uploader{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    height:7rem;line-height: 7rem;
                    background:rgba(246,248,247,1);
                    border:0.08rem dashed rgba(101,112,133,0.5);
                    .el-upload{
                        text-align: center;
                        width: 100%;height: 100%;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(119,130,151,1);
                        .icon-shangchuan{
                            font-size: 1.2rem;
                            margin-right: 0.83rem;
                        }
                    }
                }
                .upload_progress{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    display: flex;
                    justify-content: space-between;
                    .l{
                        display: flex;
                    }
                    .i_box{
                        margin-right: 0.5rem;
                        width:1.5rem;text-align: center;
                        height:1.5rem;line-height: 1.5rem;
                        border-radius: 50%;
                        background:rgba(235,239,242,1);
                        color: rgba(198, 205, 213, 1);
                    }
                    .text{
                        margin-right: 2rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                    }
                    .el-progress{
                        width: 16rem;height: 2rem;line-height: 2rem;
                        .el-progress-bar{
                            margin-top: 0.4rem;
                        }
                    }
                }
                .success{
                    .box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        display: flex;
                        justify-content: space-between;
                        .l{
                            display: flex;
                        }
                        .i_box{
                            margin-right: 0.5rem;
                            width:1.5rem;text-align: center;
                            height:1.5rem;line-height: 1.5rem;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .text1{
                            margin-right: 1rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(51,51,51,1);
                        }
                        .text2{
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(101,112,133,1);
                            max-width: 14rem;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .text3{
                            margin-left:2rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(101,112,133,1);
                        }
                    }
                    .logo_box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        img{
                            width: 100%;
                            max-height: 10rem;
                        }
                    }
                }
                .error{
                    .box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        display: flex;
                        justify-content: space-between;
                        .l{
                            display: flex;
                        }
                        .i_box{
                            margin-right: 0.5rem;
                            width:1.5rem;text-align: center;
                            height:1.5rem;line-height: 1.5rem;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .text1{
                            margin-right: 1rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(51,51,51,1);
                        }
                        .text2{
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(101,112,133,1);
                            max-width: 14rem;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .text3{
                            margin-left:2rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Heavy,PingFang-SC;
                            font-weight:800;
                            color:rgba(101,112,133,1);
                        }
                    }
                }
                .el-table{
                    width: calc(100% - 5rem);
                    margin: 0 2.5rem;
                    th,td{
                        font-style: 12px;
                    }
                }
                .error_title{
                    margin: 0 2rem 1rem;
                    i{
                        color: rgba(234,86,80,1);
                        font-size: 2.3rem;
                        position: relative;
                        top: 0.3rem;
                        margin-right: 1.2rem;
                    }
                }
                .error_box{
                    height: calc(100% - 5rem);
                    margin: 0 2rem;
                    span{
                        display: inline-block;
                        font-family:PingFang-SC-Medium;
                        font-weight:normal;
                        color:rgba(128,86,86,1);
                        background:rgba(250,245,245,1);
                        font-size:1.2rem;
                        height: 3.2rem;
                        line-height:3.2rem;
                        padding: 0px 1.7rem 0px 1.1rem;
                        margin: 0 1rem 1rem 0;
                    }
                }
                .verify_success{
                    text-align: center;
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
	}
</style>